<template>
<div class="contact-row" v-responsive="contactRowSizes">
        
        <img class="contact-image round white-border shadow mr-2" :src="contact.image" :alt="contact.firstName" >
        <div class="contact-details">
            <div>{{contact.firstName}} {{contact.lastName}}</div>
            <div style="font-weight:300">{{contact.mobile}}</div>
        </div>
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import { ResponsiveDirective } from "vue-responsive-components"

export default {
    data() {
        return {
            contactRowSizes: { 
                'row-layout': el => el.width >= 500,
                'card-layout': el => el.width < 500 && el.width >= 400,
                'compact-layout': el => el.width < 400,
            }
        
        }
    },

    directives: {
        responsive: ResponsiveDirective
    },

    components: {
        
    },
    
    props: {
        contact: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style>
.contact-row {
    display:flex;
    width: 100%;
    padding:10px;
    background: white;
}

.contact-row.row-layout {
    padding:5px;
}

.contact-image {
    width:48px;
    height:48px;
    border-radius:50%;
}

.row-layout .contact-image {
    width:36px;
    height:36px;
    min-width:30px;
}
.row-layout .contact-details {
    display:flex;
}
.row-layout .contact-details div {
    padding:7px 4px;
}
 
</style>




// WEBPACK FOOTER //
// ContactRow.vue?3ae9788a